module.exports = __webpack_public_path__ + "img/e.0093da46.jpg";